import React from "react";
import "./Footer.css";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="footer">
			<div className="container">
				<div className="footer-top">
					<div className="footer-brand">
						<div className="footer-logo">
							<img src="/4d745950-00e9-4912-bc42-6cd050839f42.jpg" alt="Aire Studio" className="footer-logo-img" />
							<span className="footer-logo-text">Aire Studio</span>
						</div>
						<p className="footer-tagline">
							Crafting unforgettable celebrations with artistry and care.
						</p>
					</div>

					<div className="footer-columns">
						<div className="footer-column">
							<h4 className="footer-column-title">Collections</h4>
							<ul className="footer-list">
								<li><a href="#categories">Balloon Bouquets</a></li>
								<li><a href="#categories">Gift Baskets</a></li>
								<li><a href="#categories">Balloon Arches</a></li>
							</ul>
						</div>

						<div className="footer-column">
							<h4 className="footer-column-title">Company</h4>
							<ul className="footer-list">
								<li><a href="#about">About</a></li>
								<li><a href="#contact">Contact</a></li>
								<li><a href="/order">Order</a></li>
							</ul>
						</div>

						<div className="footer-column">
							<h4 className="footer-column-title">Contact</h4>
							<ul className="footer-list">
								<li><a href="mailto:airestudioltd@gmail.com">airestudioltd@gmail.com</a></li>
								<li><a href="tel:+16049284992">(604) 928-4992</a></li>
								<li><span>Mon-Fri 10AM-6PM</span></li>
								<li><span>Sat 10AM-2PM</span></li>
							</ul>
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<p className="footer-copyright">
						&copy; {currentYear} Aire Studio. All rights reserved.
					</p>
					<div className="footer-social">
						<a href="#" className="footer-social-link" aria-label="Instagram">
							<i className="fab fa-instagram"></i>
						</a>
						<a href="#" className="footer-social-link" aria-label="Facebook">
							<i className="fab fa-facebook-f"></i>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
